import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import * as _ from 'lodash';
import { Observable,of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService, BudgetType, CacheService } from '@mapfre-tech/amap3';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})

export class BudgetService {

  className = 'BudgetService';

  constructor(private http: HttpClient, private authService: AuthService, private router: Router, private cacheService: CacheService) { }

  getAllBudget(orgStructId = '', exercise = null): Observable<any[]> {
    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    const params: any = {};
    if (exercise) {
      params.exercise = exercise;
    }
    return this.http.get<any[]>(environment.base_URL + `/budgets/os/${orgStructId}`, { params }).pipe(map(res => {
      return _.filter(res, it => it.nmrExercise === exercise);
    }));
  }

  getAllByAuthUser(params): Observable<any[]> {
    return this.http.get<any[]>(environment.base_URL + `/budgets`,{params})
  }
  getGrouped() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getBudgetById(budgetId, changeToEuro = false): Observable<any[]> { //changeToEuro 
    const end = changeToEuro ? '?changeToEuro=true' : '';
    return this.http.get<any[]>(environment.base_URL + `/budgets/${budgetId}` + end)
  }

  getBudgetTemplate(orgStructId = '', exercise = null): Observable<any[]> {

    const params = new HttpParams().set('exercise', exercise ?? '');

    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    return this.http.get<any[]>(environment.base_URL + `/budgets/template/${orgStructId}`, { params: params })
  }

  newBudget(budget) {
    return this.http.post(environment.base_URL + "/budgets", budget);
  }

  updateBudget(editedBudget, budgetId) {
    return this.http
      .put(environment.base_URL + `/budgets/${budgetId}`, editedBudget)
  }

  statusBudgetType(cache = true, cacheKey = "budgetType"): Observable<any[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<any[]>(environment.base_URL + `/budgets/types`).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getBudgetTracking(budgetId, changeToEuro = false): Observable<any[]> {
    const end = changeToEuro ? '?changeToEuro=true' : '';
    return this.http.get<any[]>(environment.base_URL + `/budget-tracking/${budgetId}` + end)
  }

  updateBudgetTracking(editedBudget, budgetId) {
    return this.http
      .put(environment.base_URL + `/budgets/${budgetId}`, editedBudget)
  }

  groupBudget(idBudgets) { // idBudgets: []ids
    return this.http.post(environment.base_URL + "/budgets/group", idBudgets);
  }

  newComment(comment, idBudget) {
    return this.http.post(environment.base_URL + `/budgets/comment/${idBudget}`, comment);
  }

  /**
   *  Budget Types
   */

  getAllBudgetTypes(cache = true, cacheKey = "budgetStatusTypes"): Observable<BudgetType[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<BudgetType[]>(environment.base_URL + "/budget-status-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newBudgetType(language) {
    return this.http.post(environment.base_URL + "/budget-status-types", language)
  }

  updateBudgetType(language, id) {
    return this.http.put(environment.base_URL + `/budget-status-types/${id}`, language)
  }

  /**
 *  Budget Expenses
 */

  getAllExpensesBudgetTypes(cache = true, cacheKey = "budgetExpenseTypes"): Observable<BudgetType[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<BudgetType[]>(environment.base_URL + "/budget-expense-types").pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey)
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  

  newBudgetExpensesType(language) {
    return this.http.post(environment.base_URL + "/budget-expense-types", language)
  }

  updateBudgetExpensesType(language, id) {
    return this.http.put(environment.base_URL + `/budget-expense-types/${id}`, language)
  }
}
